import type { ReactNode } from 'react';

export const symbol_turn_sharp_left: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M650-150v-220H310q-24.75 0-42.37-17.63Q250-405.25 250-430v-296l-69 69q-9 9-21 9t-21-9q-9-9-9-21t9-21l120-120q9-9 21-9t21 9l120 120q9 9 9 21t-9 21q-9 9-21 9t-21-9l-69-69v296h340q24.75 0 42.38 17.62Q710-394.75 710-370v220q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37Z"
		/>
	</svg>
);
